export default __webpack_public_path__ + "static/media/apple-juice.d951c049.png";